import { render, staticRenderFns } from "./PlantCompanyStatic.vue?vue&type=template&id=6be88eba&lang=html&"
import script from "./PlantCompanyStatic.vue?vue&type=script&lang=js&"
export * from "./PlantCompanyStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
